import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import { Input } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface ISimpleRenameTitleProps extends IBaseProps {}

const SimpleRenameTitle: React.FC<ISimpleRenameTitleProps> = (props) => {
  const { style, className, placeholder = 'Please input name', value, onChange, onBlur, ...restProps } = props;

  const rootNode = useRef<HTMLDivElement | null>(null);

  const [isEditing, setIsEditing] = useState(false);

  const [name, setName] = useState(value);

  const handleChange = (payload: string) => {
    const nameTmp = payload?.trim() || value;
    setName(nameTmp);
    setIsEditing(false);
    onChange?.(nameTmp);
  };

  useEffect(() => {
    if (isEditing) {
      rootNode.current?.querySelector<HTMLInputElement>('.dbg-simple-rename-title__input')?.focus();
    }
  }, [isEditing]);

  useEffect(() => {
    if (name !== value) {
      setName(value);
    }
  }, [value]);

  return (
    <div ref={rootNode} style={style} className={classnames('dbg-simple-rename-title', className)}>
      {isEditing && (
        <Input
          {...restProps}
          className="dbg-simple-rename-title__input"
          placeholder={placeholder}
          value={name}
          onChange={(payload: string) => {
            setName(payload);
          }}
          onBlur={(e) => {
            handleChange(name);
            onBlur?.(e);
          }}
          onPressEnter={handleChange}
        />
      )}
      {isEditing || (
        <span
          className="dbg-simple-rename-title__text"
          onClick={(e) => {
            e?.stopPropagation();
            setIsEditing(true);
          }}
        >
          {value}
        </span>
      )}
      <SvgIcon
        className={classnames('dbg-simple-rename-title__icon', { hidden: isEditing })}
        type="pencil-m"
        onClick={(e) => {
          e?.stopPropagation();
          setIsEditing(true);
        }}
      />
    </div>
  );
};

export default SimpleRenameTitle;
